/* eslint camelcase: 0 */
import React from 'react'
import { useSelector } from 'react-redux'

export const ConstructorMeta = () => {
  const { request, result_id } = useSelector(it => it.data.meta) || {}
  const term = useSelector(it => it.data?.term)
  const total = useSelector(it => it.data?.products?.quantity)

  const metaProps = {
    [term ? 'data-search-results' : 'data-browse-results']: true,
    'data-num-results': total
  }

  return (
    <>
      <meta {...metaProps} />
      <script
        id='cnstrc-data'
        type='application/json'
        dangerouslySetInnerHTML={{ __html: JSON.stringify({ request, result_id }) }}
      />
    </>
  )
}
